var DividerData_LineStyle = /* @__PURE__ */ ((DividerData_LineStyle2) => {
  DividerData_LineStyle2["SINGLE"] = "SINGLE";
  DividerData_LineStyle2["DOUBLE"] = "DOUBLE";
  DividerData_LineStyle2["DASHED"] = "DASHED";
  DividerData_LineStyle2["DOTTED"] = "DOTTED";
  DividerData_LineStyle2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return DividerData_LineStyle2;
})(DividerData_LineStyle || {});
var DividerData_Width = /* @__PURE__ */ ((DividerData_Width2) => {
  DividerData_Width2["LARGE"] = "LARGE";
  DividerData_Width2["MEDIUM"] = "MEDIUM";
  DividerData_Width2["SMALL"] = "SMALL";
  DividerData_Width2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return DividerData_Width2;
})(DividerData_Width || {});
var DividerData_Alignment = /* @__PURE__ */ ((DividerData_Alignment2) => {
  DividerData_Alignment2["CENTER"] = "CENTER";
  DividerData_Alignment2["LEFT"] = "LEFT";
  DividerData_Alignment2["RIGHT"] = "RIGHT";
  DividerData_Alignment2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return DividerData_Alignment2;
})(DividerData_Alignment || {});
export {
  DividerData_Alignment,
  DividerData_LineStyle,
  DividerData_Width
};
//# sourceMappingURL=plugin_divider.enums.js.map
